<script>
import { useLanguage } from '../composables/useLanguage';
import { computed, ref, watch } from 'vue';
import { useRoute } from 'vue-router';

export default {
	name: 'LanguageSwitcher',
	setup() {
		const { currentLanguage, availableLanguages, setLanguage } =
			useLanguage();
    const route = useRoute();
		const isDropdownOpen = ref(false);
    const isFansiteRoute = computed(() => route.path.startsWith('/fansite'));

    watch(
      isFansiteRoute,
      (isFansite) => {
        if (isFansite) {
          setLanguage('id');
          isDropdownOpen.value = false;
        }
      },
      { immediate: true }
    );

		const flagMap = {
			id: require('@/assets/images/lang/id.svg'),
			en: require('@/assets/images/lang/gb.svg'),
		};

		const handleLanguageSelect = (langCode) => {
			setLanguage(langCode);
			isDropdownOpen.value = false;
		};

		const getCurrentLang = () => {
			return availableLanguages.find((lang) => lang.code === currentLanguage.value);
		};

		return {
			currentLanguage,
			availableLanguages,
			flagMap,
			isDropdownOpen,
      isFansiteRoute,
			handleLanguageSelect,
			getCurrentLang,
		};
	},
};
</script>

<template>
  <div class="language-switcher relative">
    <!-- Language Switcher Button -->
    <button
      class="flex items-center gap-2 px-3 py-2 bg-primary-light dark:bg-ternary-dark rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-transparent hover:border-gray-300 dark:hover:border-gray-600"
      :title="getCurrentLang()?.name"
      :disabled="isFansiteRoute"
      @click="isDropdownOpen = !isDropdownOpen"
    >
      <img
        :src="flagMap[currentLanguage]"
        :alt="currentLanguage"
        class="w-5 h-5 rounded"
      >
      <span class="hidden sm:inline text-sm font-medium text-secondary-dark dark:text-ternary-light">
        {{ currentLanguage.toUpperCase() }}
      </span>
    </button>

    <!-- Dropdown Menu -->
    <div
      v-if="!isFansiteRoute"
      v-show="isDropdownOpen"
      class="absolute right-0 mt-2 w-48 bg-white dark:bg-ternary-dark rounded-lg shadow-lg border border-gray-200 dark:border-secondary-dark z-50 overflow-hidden"
    >
      <button
        v-for="lang in availableLanguages"
        :key="lang.code"
        :class="[
          'w-full flex items-center gap-3 px-4 py-3 transition-colors duration-150',
          currentLanguage === lang.code
            ? 'bg-blue-600 text-white'
            : 'text-secondary-dark dark:text-ternary-light hover:bg-gray-100 dark:hover:bg-secondary-dark'
        ]"
        @click="handleLanguageSelect(lang.code)"
      >
        <img
          :src="flagMap[lang.code]"
          :alt="lang.name"
          class="w-6 h-6 rounded"
        >
        <span class="text-sm font-medium">{{ lang.name }}</span>
      </button>
    </div>

    <!-- Backdrop to close dropdown -->
    <div
      v-if="!isFansiteRoute"
      v-show="isDropdownOpen"
      class="fixed inset-0 z-40"
      @click="isDropdownOpen = false"
    />
  </div>
</template>

<style scoped></style>
